import { createStore } from '@xstate/store';
import { useSelector } from '@xstate/store/react';

const summaryContentRefStore = createStore(
  { contentRef: null as HTMLDivElement | null },
  {
    setContentRef: (
      _ctx: { contentRef: HTMLDivElement | null },
      event: { ref: HTMLDivElement | null },
    ) => ({
      contentRef: event.ref,
    }),
  },
);

/**
 * Hook to get and set the summary content ref
 * @returns The content ref and a function to set it
 */
export const useSummaryContentRef = () => {
  const contentRef = useSelector(
    summaryContentRefStore,
    (s) => s.context.contentRef,
  );

  return {
    contentRef,
    setContentRef: (ref: HTMLDivElement | null) =>
      summaryContentRefStore.send({ type: 'setContentRef', ref }),
  };
};
